import CheckboxInput from 'LuxKit/Checkbox/CheckboxInput'
import { MAX_COMPARISON_SELECTIONS } from 'constants/offer'
import { stopPropagation } from 'lib/web/eventHandlerUtils'
import { rem } from 'polished'
import React, { useCallback } from 'react'
import styled from 'styled-components'
import Tooltip from 'LuxKit/Tooltip'
import { useAppSelector } from 'hooks/reduxHooks'
import { isSpoofed } from 'selectors/featuresSelectors'
import { MultiCartContext } from 'machines/cart/MultiCartMachineProvider'
import { useSelector } from '@xstate/react'

const Root = styled.div`
  display: inline-block;
  padding-bottom: ${rem(12)};
`

interface Props {
  cartItemId: string
  cartId: string
  offerType: App.OfferType
  offerId: string
  name: string
  roomId?: string
  packageUniqueKey?: string
  filters?: App.OfferListFilters
  priceTotals?: {
    price: number
    memberPrice: number
    value: number
  }
}

function MultiCartAccommodationTileComparisonCheckbox({
  packageUniqueKey,
  offerType,
  offerId,
  name,
  filters,
  roomId,
  priceTotals,
  cartItemId,
  cartId
}: Props) {
  const multiCartActorRef = MultiCartContext.useActorRef()
  const currentSelections = useSelector(multiCartActorRef, (snapshot) => (snapshot.context.cartSpoofedSelections.status === 'loaded'
    ? snapshot.context.cartSpoofedSelections.data[cartId] || []
    : []
  ))

  const isSpoofedEnabled = useAppSelector(isSpoofed)
  const canAddSelection = currentSelections.length < MAX_COMPARISON_SELECTIONS
  const currentSelection = currentSelections.find(s => s.selectionId === cartItemId)
  const isSelected = !!currentSelection

  const onToggle = useCallback(() => {
    if (currentSelection) {
      multiCartActorRef.send({
        type: 'remove cart offer comparison selection',
        cartId,
        selectionId: currentSelection.selectionId
      })
    } else {
      multiCartActorRef.send({
        type: 'add cart offer comparison selection',
        cartId,
        selection: {
          selectionId: cartItemId,
          offerType,
          offerId,
          name,
          priceTotals,
          params: { packageUniqueKey, roomId, filters }
        }
      })
    }
  }, [currentSelection, multiCartActorRef, cartId, cartItemId, offerType, offerId, name, roomId, filters, priceTotals, packageUniqueKey])

  const checkboxDisabled = !isSelected && !canAddSelection

  if (!isSpoofedEnabled) {
    return null
  }

  return (
    <Tooltip description={`Only ${MAX_COMPARISON_SELECTIONS} offers can be compared at a time`} disabled={!checkboxDisabled}>
      <Root onClick={stopPropagation}>
        <CheckboxInput
          onChange={onToggle}
          disabled={checkboxDisabled}
          checked={isSelected}
        >
          Compare
        </CheckboxInput>
      </Root>
    </Tooltip>
  )
}

export default MultiCartAccommodationTileComparisonCheckbox
